"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tertiaryButtons = void 0;
var material_1 = require("@mui/material");
var common_1 = require("./common");
exports.tertiaryButtons = [
    {
        props: { variant: 'tertiaryDefault' },
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common_1.buttonsCommon), { color: theme.palette.secondary.main, '&:hover': {
                    backgroundColor: (0, material_1.alpha)(theme.palette.neutrals.disabled, 0.2),
                }, '&:focus': {
                    backgroundColor: (0, material_1.alpha)(theme.palette.neutrals.disabled, 0.2),
                }, '&:active': {
                    color: theme.palette.text.light,
                    backgroundColor: (0, material_1.alpha)(theme.palette.neutrals.disabled, 0.6),
                }, '&:disabled': {
                    color: theme.palette.text.disabled,
                } }));
        },
    },
    {
        props: { variant: 'tertiaryHC' },
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common_1.buttonsCommon), { color: theme.palette.text.light, '&:hover': {
                    backgroundColor: (0, material_1.alpha)(theme.palette.neutrals.disabled, 0.2),
                }, '&:focus': {
                    backgroundColor: (0, material_1.alpha)(theme.palette.neutrals.disabled, 0.2),
                }, '&:active': {
                    backgroundColor: (0, material_1.alpha)(theme.palette.neutrals.disabled, 0.6),
                }, '&:disabled': {
                    color: theme.palette.text.disabled,
                } }));
        },
    },
    {
        props: { variant: 'textNotification' },
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common_1.buttonsCommon), { minHeight: '1.25rem', minWidth: '3.375rem', fontSize: '0.75rem', textTransform: 'uppercase', color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")"), '&:disabled': {
                    color: "var(--text-disabled, ".concat(theme.palette.text.disabled, ")"),
                } }));
        },
    },
];
